import { X } from 'lucide-react';

import { cn } from '@/lib/utils';

import type { TagDefinition } from '@repo/shared-types';

/** Fallback for tags that have no definition yet (matches the old gray chip). */
const DEFAULT_COLOR = '#6b7b8d';

export const tagColor = (definition?: TagDefinition): string => definition?.color || DEFAULT_COLOR;

/**
 * Colored tag chip. The color comes from the tag catalog (Settings → Sales
 * Console); undefined tags render in a neutral gray.
 */
export const TagBadge = ({
  name,
  definition,
  size = 'sm',
  onRemove,
  className,
}: {
  name: string;
  definition?: TagDefinition;
  size?: 'xs' | 'sm';
  onRemove?: () => void;
  className?: string;
}) => {
  const color = tagColor(definition);
  const type = definition?.type?.trim();
  return (
    <span
      className={cn(
        'inline-flex max-w-full items-center gap-0.5 rounded-full font-medium',
        size === 'xs' ? 'px-1.5 py-px text-[10px]' : 'px-2 py-0.5 text-[11px]',
        className,
      )}
      style={{ backgroundColor: `${color}26`, color }}
      title={type ? `${type}: ${name}` : name}
    >
      <span className="truncate">{name}</span>
      {onRemove && (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onRemove();
          }}
          className="ml-0.5 shrink-0 cursor-pointer opacity-60 transition-opacity hover:opacity-100"
        >
          <X className={size === 'xs' ? 'h-2.5 w-2.5' : 'h-3 w-3'} />
        </button>
      )}
    </span>
  );
};
